import { render } from "./audio-recorder.vue?vue&type=template&id=5817da7d&scoped=true"
import script from "./audio-recorder.vue?vue&type=script&lang=js"
export * from "./audio-recorder.vue?vue&type=script&lang=js"

import "./audio-recorder.vue?vue&type=style&index=0&id=5817da7d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5817da7d"]])

export default __exports__